import { useUIStore } from '@/shared/stores/uiStore';
import { useAuthStore } from '@/shared/stores/authStore';
import { Bell, Menu, LogOut } from 'lucide-react';
import { cn } from '@/shared/lib/utils';
import { IconButton } from '@/shared/ui/icon-button/IconButton';

export function Header() {
  const toggleSidebar = useUIStore(state => state.toggleSidebar);
  const isMobile = useUIStore(state => state.isMobile);
  const user = useAuthStore(state => state.user);
  const logout = useAuthStore(state => state.logout);

  return (
    <header
      className={cn(
        'sticky top-0 z-20 flex h-18 items-center justify-between gap-4 border-b border-border bg-surface/80 px-4 py-3 backdrop-blur-xl',
        'lg:px-8'
      )}
    >
      <div className="flex items-center gap-3">
        {isMobile && (
          <IconButton
            variant="ghost"
            size="sm"
            aria-label="Abrir menú"
            onClick={toggleSidebar}
          >
            <Menu className="h-5 w-5" />
          </IconButton>
        )}

        <div className="hidden flex-col lg:flex">
          <h1 className="font-display text-lg font-bold leading-tight text-text-primary">
            Panel Ejecutivo
          </h1>
          <p className="text-xs text-text-muted">
            {new Date().toLocaleDateString('es-CR', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <div className="mr-2 hidden flex-col items-end sm:flex">
          <span className="text-sm font-semibold text-text-primary">
            {user?.nombre || 'Usuario'}
          </span>
          <span className="text-xs text-text-muted">{user?.email || user?.cedula}</span>
        </div>

        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-surface-elevated text-sm font-bold text-primary ring-2 ring-primary-muted sm:hidden">
          {(user?.nombre || 'U').charAt(0)}
        </div>

        <IconButton
          variant="ghost"
          size="sm"
          aria-label="Notificaciones"
          className="relative"
        >
          <Bell className="h-5 w-5" />
          <span
            className="absolute right-2 top-2 h-2 w-2 rounded-full bg-secondary ring-2 ring-surface"
            aria-hidden
          />
        </IconButton>

        <IconButton
          variant="ghost"
          size="sm"
          aria-label="Cerrar sesión"
          onClick={logout}
          className="hidden sm:flex"
        >
          <LogOut className="h-5 w-5" />
        </IconButton>
      </div>
    </header>
  );
}
